<script setup lang="ts">
import { DialogOverlay } from "reka-ui";
</script>

<template>
  <DialogOverlay class="animation-fade wp-top-0 fixed inset-0 bg-black/50" />
</template>
